//@flow
import React from 'react';
import {makeStyles, Typography} from '@material-ui/core';
import VariableInput from './variable-input';

type TemplateVariable = {
  id: string,
  scope: 'HEADER' | 'BODY',
  name?: string,
  position?: number,
  value: string,
};

type Props = {
  title: string,
  templateText?: string,
  variables: TemplateVariable[],
  onVariableChange: (id: string, value: string) => void,
  enabledVariables?: boolean,
};

const useStyles = makeStyles(() => ({
  inputSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  headerText: {
    fontSize: '12px',
    fontWeight: 600,
  },
}));

export default function VariableSection({
  title,
  templateText,
  variables,
  onVariableChange,
  enabledVariables,
}: Props) {
  const classes = useStyles();

  if (!templateText || variables.length === 0) {
    return null;
  }

  return (
    <div className={classes.inputSection}>
      <Typography className={classes.headerText}>{title}</Typography>
      <Typography variant="caption">{templateText}</Typography>
      {variables.map(variable => {
        const label = variable.name || `Variable ${variable.position}`;

        return (
          <VariableInput
            key={variable.id}
            text={variable.value}
            placeholder={label}
            onChange={value => onVariableChange(variable.id, value)}
            disabledCommands={!enabledVariables}
          />
        );
      })}
    </div>
  );
}
